// Estilos
import "./phoneFrame.css";

/**
 * Moldura de celular compartilhada pelos previews de tela do app. O conteúdo
 * recebido ocupa a área da tela.
 */
export default function PhoneFrame({ backgroundColor, children }) {
  return (
    <div className="phone-frame">
      <div className="phone-frame__device">
        <div className="phone-frame__screen" style={{ backgroundColor }}>
          <div className="phone-frame__notch" />
          {children}
        </div>
      </div>
    </div>
  );
}
